import { render, staticRenderFns } from "./Group_journey.vue?vue&type=template&id=af2a8f94&scoped=true"
import script from "./Group_journey.vue?vue&type=script&lang=js"
export * from "./Group_journey.vue?vue&type=script&lang=js"
import style0 from "./Group_journey.vue?vue&type=style&index=0&id=af2a8f94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af2a8f94",
  null
  
)

export default component.exports